<template>
  <div class="business-rules">
    <drop-down
      class="rule-dropdown mr-1"
      v-model="businessRuleId"
      id="display-rule"
      name="display-rule"
      label="Display Rule"
      :items="businessRuleItems"
      include-empty-option
      allow-select-empty-option
      empty-option-message="<No Rule>"
    ></drop-down>
    <div class="new-button-container">
      <button
        type="button"
        class="btn btn-primary small"
        @click="$emit('new-rule')"
      >
        New Rule
      </button>
    </div>
  </div>
</template>
<script>
import documentModelMixin from "@/mixins/documentModel";

export default {
  mixins: [documentModelMixin],
  props: {
    modelValue: {
      required: true,
    },
  },
  computed: {
    businessRuleId: {
      get: function() {
        return this.modelValue;
      },
      set: function(value) {
        this.logDebug("Display rule selected.", { id: value });
        this.$emit("update:modelValue", value);
      },
    },
    businessRuleItems: function() {
      if (this.documentModel && this.documentModel.businessRules) {
        return this.documentModel.businessRules.map((r) => ({
          label: r.name,
          value: r.id,
        }));
      }

      return [];
    },
  },
  emits: ["update:modelValue", "new-rule"],
};
</script>
<style lang="scss" scoped>
.business-rules {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 1.5rem;

  & > .rule-dropdown {
    flex-grow: 1;
  }
}
</style>
